import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button, Modal, Popconfirm, Tag, Tooltip } from "antd";
import { AppStore } from "~/stores/AppStore";
import { computed, observable, toJS } from "mobx";
import { awesomeIcon } from "../../../utils/helpers";
import dayjs from "dayjs";
import { translateKey as t } from "../../../locales/translation";

@inject("store")
@observer
export default class PageSettings extends Component<{
  store?: AppStore;
  recent?: boolean;
}> {
  @observable private showModal = false;
  @observable private type: "most" | "recent" = "most";

  @computed get settingsData() {
    const pageStats = this.props.store.getPageStats(15);

    if (pageStats) {
      return this.type === "most" ? pageStats.most : pageStats.recent;
    }

    return [];
  }

  public openModal = (type: "most" | "recent") => {
    this.type = type;
    this.showModal = true;
  };

  private closeModal = () => {
    this.showModal = false;
  };

  private removeAll = async () => {
    await this.props.store.updateUserPreferences("pageSettings." + this.type, []);
    this.closeModal();
  };

  private renderActionBtns = () => {
    return (
      <div className="flex items-center">
        <Popconfirm
          placement="top"
          title={t("lblAreYourSure", "Are you sure?")}
          onConfirm={() => this.removeAll()}
          okText={t("lblYes", "Yes")}
          cancelText={t("lblNo", "No")}
          okType="danger"
          disabled={this.props.store.loadingUserPreferences}
        >
          <Button size="small" danger disabled={this.props.store.loadingUserPreferences}>
            {t("lblRemoveAll", "Remove All")}
          </Button>
        </Popconfirm>
      </div>
    );
  };

  private renderList = () => {
    const elements = [];

    this.settingsData.forEach((d, i) => {
      elements.push(
        <div className="flex items-center mt-3" key={d._id}>
          <div className="pageSettings" onClick={() => (window.location = d.path)}>
            <div className="mx-3">{awesomeIcon(d.icon, "1x")}</div>
            <div className="flex-1">
              <b>{d.name.split(" - ")[1]}</b>
              <span> - {d.name.split(" - ")[0]}</span>
            </div>
          </div>
          <div className="flex">
            {this.type === "most" ? (
              <Tooltip title={t("lblTotalViews", "Total Views")} mouseLeaveDelay={0}>
                <Tag className="font-bold">
                  {awesomeIcon("eye", "1x")}
                  {/* <Icon type="eye" className="mr-3" /> */}
                  {d.count}
                </Tag>
              </Tooltip>
            ) : (
              <Tooltip title={t("lblTimestamp", "Timestamp")} mouseLeaveDelay={0}>
                <Tag className="font-bold">
                  {awesomeIcon("clock", "1x")}
                  {/* <Icon type="clock-circle" className="mr-3" /> */}
                  {dayjs(d.timestamp).format("MMM Mo HH:mm")}
                </Tag>
              </Tooltip>
            )}
            <Tooltip title={t("lblRemove", "Remove")} mouseLeaveDelay={0}>
              <Button
                size="small"
                icon="delete"
                danger
                disabled={this.props.store.loadingUserPreferences}
                onClick={() => {
                  const settings = toJS(this.settingsData);

                  settings.splice(i, 1);

                  this.props.store.updateUserPreferences("pageSettings." + this.type, settings);

                  if (settings.length === 0) {
                    this.closeModal();
                  }
                }}
              />
            </Tooltip>
          </div>
        </div>
      );
    });

    return (
      <div className="header p-5">
        {this.renderActionBtns()}
        {elements}
      </div>
    );
  };

  public render() {
    return (
      <Modal
        title={
          this.type === "most"
            ? t("lblMostVisitedPages", "Most Visited Pages")
            : t("lblMostRecentPages", "Most Recent Pages")
        }
        centered={true}
        open={this.showModal}
        onCancel={() => this.closeModal()}
        bodyStyle={{ height: 400, padding: 0, overflow: "auto" }}
        footer={null}
        width={600}
        getContainer={() => window.document.getElementById("pageSettings")}
      >
        {this.renderList()}
      </Modal>
    );
  }
}
